import React from 'react';
import { Link } from 'react-router-dom';

export function BottomNav() {
  return (
    <div
      data-testid="bottom-nav"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-fade-in-up"
      style={{ animationDelay: '1s' }}
    >
      <div className="bg-white rounded-full pl-3 pr-2 py-2 flex items-center justify-between gap-4 shadow-[0_1px_2px_0_rgba(5,26,36,0.1),0_4px_4px_0_rgba(5,26,36,0.09),0_9px_6px_0_rgba(5,26,36,0.05),0_17px_7px_0_rgba(5,26,36,0.01),0_26px_7px_0_rgba(5,26,36,0)] border border-[#7C3AED]/10">
        <Link to="/" className="flex items-center gap-1">
          <img
            src="/yp-nova-logo.jpg"
            alt="YP Nova"
            className="h-12 md:h-14 w-auto object-contain"
          />
        </Link>
        <Link
          to="/contact"
          className="inline-flex items-center bg-gradient-to-r from-[#051A24] to-[#6D28D9] text-white rounded-full px-6 py-2.5 text-sm font-medium hover:shadow-[0_8px_28px_rgba(109,40,217,0.45)] transition-shadow"
        >
          Book a Discovery Call
        </Link>
      </div>
    </div>
  );
}
